import {fromJson, toJson} from '../core/data-source/json.mapper';
import {DataSource} from '../core/data-source/data-source';
import {httpService} from '../core/services/http.service';
import {OrderItemsDeliveryReportFilterRecord} from '../components/reports/order-items-delivery/order-items-delivery-report-filter.record';

export class FilterDataSource<T> extends DataSource<T> {
    protected apiPath: string = '/gt/gt-api/filters';

    async getVehicleFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/resources').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async getDriverFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/drivers').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveVehicleFilter(record: T): Promise<T> {
        return httpService.post(this.apiPath + '/resources', toJson(record)).then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveDriverFilter(record: T): Promise<T> {
        return httpService.post(this.apiPath + '/drivers', toJson(record)).then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async getOrderFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/orders').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveOrderFilter(record: T): Promise<T> {
        return httpService.post(this.apiPath + '/orders', toJson(record)).then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    // All filters regarding to the report

    async getDriverPerformanceFilter(): Promise<T> {
        return httpService
            .get(this.apiPath + '/generic/get/report/performerPerformanceReport')
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }

    async saveDriverPerformanceFilter(record: T): Promise<T> {
        return httpService
            .post(this.apiPath + '/generic/save/report/performerPerformanceReport', toJson(record))
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }

    async getDeliveryRateReportFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/generic/get/report/rateDeliveryReport').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveDeliveryRateReportFilter(record: T): Promise<T> {
        return httpService
            .post(this.apiPath + '/generic/save/report/rateDeliveryReport', toJson(record))
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }

    async getFuelCostFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/generic/get/report/loadReport').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveFuelCostFilter(record: T): Promise<T> {
        return httpService
            .post(this.apiPath + '/generic/save/report/loadReport', toJson(record))
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }

    async getDailyRunsFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/generic/get/report/dailyRunsReport').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveDailyRunsFilter(record: T): Promise<T> {
        return httpService
            .post(this.apiPath + '/generic/save/report/dailyRunsReport', toJson(record))
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }

    async getOrderItemsReportFilter(): Promise<OrderItemsDeliveryReportFilterRecord> {
        return httpService.get(this.apiPath + '/generic/get/report/orderItemsReport').then((response: any) => {
            return fromJson(OrderItemsDeliveryReportFilterRecord, response.data.rows[0]);
        });
    }

    async saveOrderItemsReportFilter(record: T): Promise<OrderItemsDeliveryReportFilterRecord> {
        return httpService
            .post(this.apiPath + '/generic/save/report/orderItemsReport', toJson(record))
            .then((response: any) => {
                return fromJson(OrderItemsDeliveryReportFilterRecord, response.data.rows[0]);
            });
    }

    async getOnTimeReportFilter(): Promise<T> {
        return httpService.get(this.apiPath + '/generic/get/report/onTimeReport').then((response: any) => {
            return fromJson(this.recordClass, response.data.rows[0]);
        });
    }

    async saveOnTimeReportFilter(record: T): Promise<T> {
        return httpService
            .post(this.apiPath + '/generic/save/report/onTimeReport', toJson(record))
            .then((response: any) => {
                return fromJson(this.recordClass, response.data.rows[0]);
            });
    }
}
